import { QueryHookOptions, useQuery } from "@apollo/react-hooks";

import { Region } from "@hubcapp/types";

import discountsQuery from "../graph-ql/discounts.graphql";

const useQueryDiscounts = (
  id?: string,
  propositionId?: string,
  productCategoryId?: string,
  onCompleted?: QueryHookOptions["onCompleted"],
) =>
  useQuery<{ region: Region }>(discountsQuery, {
    variables: {
      id,
      propositionId,
      productCategoryId,
    },
    skip: !id,
    fetchPolicy: "cache-first",
    onCompleted,
  });

export default useQueryDiscounts;
